// Page Boxed mixins
export const PageBoxed = {
  created() {
    this.$store.commit("appConfig/UPDATE_CONTENT_WIDTH", "boxed");
  },
  destroyed() {
    this.$store.commit("appConfig/UPDATE_CONTENT_WIDTH", "full");
  },
};
